import { Box, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import {
  CustomButton,
  CustomSelect,
  CustomTextField,
  HeaderFilterBox,
} from '../../../common';
import { ICBC_CURRENCY_OPTIONS } from '../constants/directDebitIcbcConstants';
import { toDateInputValue } from '../utils/directDebitIcbcUtils';
import DirectDebitIcbcAnalysis from './DirectDebitIcbcAnalysis';

const fieldStyles = {
  width: { xs: '100%', sm: '48%', md: '24%' },
  mb: { xs: 1, md: 0 },
};

const DirectDebitIcbcFilters = ({
  filter,
  recordsCount,
  analysis,
  isLoading,
  isExporting,
  isAnalysisLoading,
  onFilter,
  onSelectAnalysisDate,
  onSearch,
  onExport,
}) => {
  return (
    <HeaderFilterBox variant="twoRows">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          width: '100%',
        }}
      >
        <CustomTextField
          label="Vencimiento"
          name="due_date"
          type="date"
          value={filter.due_date}
          onChange={onFilter}
          inputProps={{ min: toDateInputValue(new Date()) }}
          sx={fieldStyles}
          size="medium"
        />

        <CustomTextField
          label="CUIT empresa"
          name="cuit"
          value={filter.cuit}
          onChange={onFilter}
          inputProps={{ maxLength: 11 }}
          sx={fieldStyles}
          size="medium"
        />

        <CustomSelect
          label="Tipo de moneda"
          name="currency"
          value={filter.currency}
          onChange={onFilter}
          sx={fieldStyles}
          size="medium"
        >
          {ICBC_CURRENCY_OPTIONS.map((currency) => (
            <MenuItem key={currency.value} value={currency.value}>
              {currency.label}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>

      <DirectDebitIcbcAnalysis
        analysis={analysis}
        isLoading={isAnalysisLoading}
        selectedDueDate={filter.due_date}
        selectedPeriodMonth={filter.month}
        selectedPeriodYear={filter.year}
        onSelectAnalysisDate={onSelectAnalysisDate}
      />

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          gap: 2,
          width: '100%',
          mt: 2,
        }}
      >
        <CustomButton
          variant="base"
          buttonIcon={SearchIcon}
          onClick={onSearch}
          isLoading={isLoading}
          sx={{ width: { xs: '100%', sm: 220 } }}
        >
          Consultar
        </CustomButton>
        <CustomButton
          variant="info"
          buttonIcon={DownloadIcon}
          onClick={onExport}
          isLoading={isExporting}
          disabled={!recordsCount || isLoading}
          sx={{ width: { xs: '100%', sm: 240 } }}
        >
          Descargar archivos
        </CustomButton>
      </Box>
    </HeaderFilterBox>
  );
};

export default DirectDebitIcbcFilters;
